// src/lib/constants/routes.ts
export const ROUTES = {
    // Public
    HOME: '/',
    COURSES: '/courses',
    COURSE_DETAILS: '/courses/:slug',
    PUBLIC_INSTRUCTOR_PROFILE: '/instructors/:slug',
    PRICING: '/pricing',
    FAQ: '/faq',
    CONTACT: '/contact',
    TERMS: '/terms',
    PRIVACY: '/privacy',

    // Auth
    LOGIN: '/auth?mode=login',
    REGISTER: '/auth',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',

    // Dashboard (Unified)
    DASHBOARD: '/dashboard',

    // Common Protected
    MY_COURSES: '/dashboard/my-courses',
    SETTINGS: '/dashboard/settings',

    // Student Specific
    STUDENT_COURSE_PLAYER: '/dashboard/courses/:id/play',
    STUDENT_CERTIFICATES: '/dashboard/certificates',
    STUDENT_PAYMENTS: '/dashboard/payments',
    CHECKOUT: '/checkout/:slug',

    // Packs
    PACKS: '/packs',
    PACK_DETAILS: '/packs/:slug',
    MY_PACKS: '/dashboard/my-packs',

    // Instructor Routes
    INSTRUCTOR_DASHBOARD: '/dashboard/instructor',
    INSTRUCTOR_COURSES: '/dashboard/instructor/courses',
    INSTRUCTOR_CREATE_COURSE: '/dashboard/instructor/courses/create',
    INSTRUCTOR_EDIT_COURSE: '/dashboard/instructor/courses/:id/edit',
    INSTRUCTOR_COURSE_STUDENTS: '/dashboard/instructor/courses/:id/students',
    INSTRUCTOR_PACKS: '/dashboard/instructor/packs',
    INSTRUCTOR_STUDENTS: '/dashboard/instructor/students',
    INSTRUCTOR_PENDING_GRADINGS: '/dashboard/instructor/pending-gradings',
    INSTRUCTOR_REVENUE: '/dashboard/instructor/revenue',
    INSTRUCTOR_KYC: '/dashboard/instructor/kyc',
    INSTRUCTOR_TEST_BUILDER: '/dashboard/instructor/tests/builder',
    INSTRUCTOR_TEST_EDIT: '/dashboard/instructor/tests/:id/edit',
    INSTRUCTOR_PUBLIC_PROFILE_SETTINGS: '/dashboard/instructor/public-profile',

    INSTRUCTOR_VIDEOS: '/dashboard/instructor/videos',

    REQUEST_MEETING: '/dashboard/request-meeting',
    GROUPS: '/dashboard/groups',
    MEETING_REQUESTS: '/dashboard/meeting-requests',

    // Admin Specific
    ADMIN_USERS: '/dashboard/users',
    ADMIN_ROLES: '/dashboard/roles',
    ADMIN_COURSES: '/dashboard/courses',
    ADMIN_EDIT_COURSE: '/dashboard/admin/courses/:id/manage',
    ADMIN_PACKS: '/dashboard/packs',
    ADMIN_EDIT_PACK: '/dashboard/admin/packs/:id/manage',
    ADMIN_PAYMENTS: '/dashboard/admin/payments',
    ADMIN_SUBSCRIPTION_PLANS: '/dashboard/subscription-plans',
    ADMIN_SETTINGS: '/dashboard/settings',
    ADMIN_KYC: '/dashboard/admin/kyc',
    ADMIN_LEGAL_LIST: '/dashboard/admin/legal',
    ADMIN_LEGAL_EDIT: '/dashboard/admin/legal/:slug/:locale',
    ADMIN_MEDIA_PROVIDERS: '/dashboard/admin/media-providers',

    // Other
    UNAUTHORIZED: '/unauthorized',
    NOT_FOUND: '/404',

    SESSIONS: '/dashboard/sessions',
    SESSION_WAITING_ROOM: '/dashboard/sessions/:id/waiting-room',
    SESSION_ROOM: '/dashboard/sessions/:id/room',
    MY_SESSIONS: '/dashboard/my-sessions',

    // Payments
    PAYMENT_SUCCESS: '/payment/success',
    PAYMENT_FAILURE: '/payment/failure',
    PAYMENT_CALLBACK: '/payment/callback',

} as const;

export type RouteKey = keyof typeof ROUTES;
export type RouteValue = typeof ROUTES[RouteKey];